// extracted by mini-css-extract-plugin
module.exports = {"albumArtFrame":"Artwork_albumArtFrame__1BXkC","croppingAlbumArt":"Artwork_croppingAlbumArt__2QTV0","cover":"Artwork_cover__2V65V"};